import React, { useEffect, useMemo, useState } from 'react';
import { makeStyles, TextField } from '@material-ui/core';
import CurrencyFormatInput from '../../../../../../../../FormikFields/CurrencyFormatInput';
import cx from 'classnames';
import { alpha } from '@material-ui/core/styles';
import CurrencyFormat from 'react-currency-format';

const useStyles = makeStyles((theme) => ({
  tableInput: {
    marginTop: 0,
  },
  tableItem: {
    // flex: 7,
    // minWidth: 260,
    // height: 72,
    position: 'relative',
  },
  textField: {
    maxWidth: 600,
    height: 44,
  },
  zIndex: {
    zIndex: 0,
  },
  root: {
    height: '100%',
    minHeight: 44,

    '& .Mui-error': {
      marginTop: 0,
    },
  },

  error: {
    '&.MuiFormHelperText-root.Mui-error': {
      color: theme.palette.common.white,
    },
  },
  lightColorBorder: {
    borderColor: alpha('#818FA0', 0.25),
  },
}));

const styles = {
  activitiesErrorStyle: {
    position: 'absolute',
    bottom: -18,
    marginLeft: 20,
  },
};

const PriceComponent = (props) => {
  const classes = useStyles();
  const {
    row: { index: i },
    backendErrors,
    updateFieldValue,
    validateField,
  } = props;
  const index = parseInt(i);
  const inputProps = {
    disableUnderline: true,
    classes: {
      notchedOutline: classes.lightColorBorder,
    },
  };

  const errors = useMemo(
    () => backendErrors && backendErrors[index] && backendErrors[index].price,
    [backendErrors],
  );

  const onUpdateFieldValue = async (key, value) => {
    updateFieldValue(index, 'price', value.replaceAll(',', ''));
    validateField(`ispConfiguration.services[${index}].price`);
  };

  return (
    <CurrencyFormatInput
      required={true}
      type="number"
      hideErrorDuringEditing
      disableUnderline
      customInput={_CustomInput}
      name={`ispConfiguration.services[${index}].price`}
      backendError={errors}
      className={classes.tableInput}
      InputProps={inputProps}
      activitiesErrorStyle={styles.activitiesErrorStyle}
      onChange={onUpdateFieldValue}
      index={index}
    />
  );
};

export default PriceComponent;

const _CustomInput = (props) => {
  const classes = useStyles();
  return (
    <TextField
      InputProps={{
        classes: {
          notchedOutline: classes.lightColorBorder,
          root: classes.root,
          error: classes.error,
        },
      }}
      className={cx(classes.textField, classes.zIndex)}
      autoComplete="off"
      fullWidth
      placeholder={'Price'}
      variant={'outlined'}
      classes={{ label: classes.label }}
      {...props}
    />
  );
};

export function useEdit(props) {
  const { cell, column, row, table } = props;
  const { getState, setEditingCell, setEditingRow, setCreatingRow } = table;
  const { editingRow, creatingRow } = getState();

  const [value, setValue] = useState(() => cell.getValue());
  const isCreating = creatingRow?.id === row.id;
  const isEditing = editingRow?.id === row.id;

  const handleOnChange = (newValue) => {
    //@ts-ignore
    row._valuesCache[column.id] = newValue;
    if (isCreating) setCreatingRow(row);
    else if (isEditing) setEditingRow(row);
    setValue(newValue);
  };

  const handleBlur = () => {
    setEditingCell(null);
  };

  return { value, handleOnChange, handleBlur, column, table };
}
